import { validateGeolocation } from 'js/hooks/auth/pas';
import { useCallback } from 'react';

export const useInitialCall = ({ setSDK, setShowOverlay, downloadSDK, geolocationType }) => {
    return useCallback(async () => {
        // initial call to understand if check is needed at all
        const response = await validateGeolocation(null, null, null, null, null, geolocationType);
        const sessionValidationData = response.data.sessionValidationData || {};
        const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
        const geolocationData = sessionValidationByGeolocationData[0] || {};
        const nextCheckIn = Number(geolocationData.nextCheckIn);

        if (!sessionValidationData.SessionValidationByGeolocationData) {
            // no geofencing -- go straight to end.
            setShowOverlay(false);
            return;
        }

        if (nextCheckIn === 0) {
            // check will be done now, so show overlay
            setShowOverlay(true);
        }

        const sdk = await downloadSDK();

        setSDK(sdk);
    }, [
        setSDK,
        setShowOverlay,
        downloadSDK,
        geolocationType
    ]);
};
